<template>
    <div>
        <template v-if="!contract.actions.block">
            <b-btn :id="blockRequestId" class="btn btn-card-action btn-card-action-danger text-uppercase my-1 inactive">Заблокировать</b-btn>
            <b-popover :target="blockRequestId" triggers="hover">
                <span class="fs-12">Запрос на блокировку на <router-link :to="{ name: 'CabinetFl44BlockRequests' }" class="atmo-button-link">рассмотрении</router-link></span>
            </b-popover>
        </template>
        <template v-else>
            <b-btn :id="blockRequestId" class="btn btn-card-action btn-card-action-danger text-uppercase my-1" @click="showBlockRequestModal = $store.getters.getCanSign && true">Заблокировать</b-btn>
            <b-popover v-if="!$store.getters.getCanSign" :target="blockRequestId" triggers="hover">
                <span v-if="$store.getters.getLoginType === 'cert'" class="fs-12">Для действия требуется загрузить/заменить МЧД на странице: <router-link :to="{ name: 'CabinetUserProfile' }" class="atmo-button-link">Данные учетной записи</router-link></span>
                <span v-else class="fs-12">Для действия требуется авторизация при помощи ЭЦП</span>
            </b-popover>
        </template>

        <b-modal v-model="showBlockRequestModal" title="Запрос блокировки внесистемной закупки" @hide="onHide" centered no-close-on-backdrop no-close-on-esc>
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <div class="d-block text-left">
                <p>Вы уверены, что хотите отправить запрос на блокировку закупки №{{ contract.purchase_info.reg_number }}?</p>
                <form-row-edit-textarea label="Введите причину запроса блокировки" v-model="blockMessage" :v="$v.blockMessage" :rows="4" label-on-top />
            </div>
            <template #modal-footer>
                <b-overlay :show="isLoading" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary"> <b-button variant="custom-outline-secondary" @click="onHide">Отмена </b-button>&nbsp; </b-overlay>
                <b-overlay :show="isLoading" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="$v.$invalid" variant="custom-danger" @click="onSubmit">Подтвердить</b-button>
                </b-overlay>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';

export default {
    name: 'cabinet-fl44-external-purchase-block-request-button',
    props: {
        contract: {
            type: Object
        }
    },
    data() {
        return {
            showBlockRequestModal: false,
            isLoading: false,
            blockMessage: ''
        };
    },
    validations() {
        return {
            blockMessage: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(200)
            }
        };
    },
    methods: {
        onHide() {
            this.blockMessage = '';
            this.showBlockRequestModal = false;
        },
        async onSubmit() {
            this.isLoading = true;
            if (await this.$api.personal.fl44ExternalPurchases.storeBlockRequest(this.blockMessage, this.contract.id)) {
                this.onHide();
                this.$emit('refresh');
            }
            this.isLoading = false;
        }
    },
    computed: {
        blockRequestId() {
            return 'popover-create-block-request-' + this._uid;
        }
    }
};
</script>
<style scoped>
    .inactive {
        opacity: 0.65;
    }
</style>
